import React from 'react';
import cn from 'classnames';

import WishListButton from '@lt/components/components/WishListButton';
import PackageId from 'src/routes/Checkout/components/PackageId';
import { vibrate } from 'src/utils/commonUtils';

import type { Props as PropsFromParentComponent, PropsFromRedux } from '.';
import styles from './wishlist.module.css';

type StyledComponentsProps = {
  className?: string;
  forceDesktop?: boolean;
};

const Wishlist = (
  props: PropsFromRedux & StyledComponentsProps & PropsFromParentComponent,
) => {
  const {
    addToWishlist,
    removeFromWishlist,
    isContainedInWishlist,
    wishlistIdentifier,
    type,
    price,
    wishlistItemId,
    isCheckoutPage,
    isHotelPage,
    isMobile,
    className,
    isHotelCardFromMap,
    requestId,
    isMobileHotelPage,
    fullMapView,
    forceDesktop,
  } = props;
  const onRemove = () => {
    removeFromWishlist(wishlistItemId || 0);
  };
  const onAdd = () => {
    addToWishlist({
      wishlistIdentifier,
      type,
      price,
      requestId,
      isFromMap: isHotelCardFromMap,
    });
  };
  const onClick = isContainedInWishlist ? onRemove : onAdd;
  const handleWishlistClicked = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onClick();
    /**
     * Вибрация устройства при добавлении и удалении
     */
    vibrate(200);
  };

  return (
    <>
      {!isCheckoutPage && !isHotelPage && (
        <WishListButton
          isSelected={isContainedInWishlist}
          onClick={handleWishlistClicked}
          className={cn(className, {
            [styles.mobileHotelWishlist]: isMobileHotelPage,
          })}
          isMobile={(isMobile || fullMapView) && !forceDesktop}
        />
      )}

      {isCheckoutPage && (
        <button type="button" onClick={onClick} className={className}>
          <PackageId />
          <WishListButton
            className={styles.checkoutWishlist}
            isSelected={isContainedInWishlist}
            onClick={handleWishlistClicked}
            isMobile={isMobile && !forceDesktop}
          />
        </button>
      )}
      {isHotelPage && (
        <WishListButton
          isMobile={isMobile && !forceDesktop}
          isSelected={isContainedInWishlist}
          onClick={handleWishlistClicked}
        />
      )}
    </>
  );
};

export default Wishlist;
